import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export interface ChatConfigSection {
  key: string;
  title: string;
  content: string;
  editable: boolean;
}

export interface ChatModelOption {
  id: string;
  label: string;
  supports_temperature: boolean;
}

export interface ChatConfig {
  model_id: string | null;
  temperature: number | null;
  max_tokens: number | null;
  prompt_sections: ChatConfigSection[];
  available_models: ChatModelOption[];
}

export interface ChatConfigUpdate {
  model_id: string | null;
  temperature: number | null;
  max_tokens: number | null;
  prompt_sections: { key: string; content: string }[];
}

const getChatConfig = async (access_token: string) => {
  return await axios.get<ChatConfig>(`${BASE_URL}/chat-config`, {
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });
};

const updateChatConfig = async (access_token: string, config: ChatConfigUpdate) => {
  return await axios.put<ChatConfig>(`${BASE_URL}/chat-config`, config, {
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });
};

export { getChatConfig, updateChatConfig };
